import HandleLettersOldDetails from './HandleLettersOldDetails.jsx';

export {
  HandleLettersOldDetails
};



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters-old/detail-handle-letters-old/index.js